import useApi from "../../api/useApi";

const useCompanyService = () => {

  const {api} = useApi()

  const userShow = (callbackSuccess, callbackValidationErrors, companyId = null) => {
    return api(
      'get',
      (companyId) ? 'user/company/' + companyId : 'user/companies',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userShow: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  const userUpdate = (callbackSuccess, callbackValidationErrors, companyId, data) => {
    return api(
      'post',
      (companyId) ? 'user/company/' + companyId + '/update' : 'user/companies/update',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userUpdate: ${error?.message || JSON.stringify(error)}`)
      },
      data,
    )
  }

  const userStore = (callbackSuccess, callbackValidationErrors, companyId, data) => {
    return api(
      'post',
      'user/companies/store',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userStore: ${error?.message || JSON.stringify(error)}`)
      },
      data,
    )
  }

  const userValidateIban = (callbackSuccess, callbackValidationErrors, companyId, callbackUrl) => {
    return api(
      'post',
      'user/company/' + companyId + '/validate/iban',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userValidateIban: ${error?.message || JSON.stringify(error)}`)
      },
      {callback_url: callbackUrl},
    )
  }

  const userValidateIbanCallback = (
    callbackSuccess,
    callbackValidationErrors,
    companyId,
    key,
  ) => {
    return api(
      'post',
      'user/company/' + companyId + '/validate/iban/callback/' + key,
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userValidateIbanCallback: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  const userValidateCoc = (callbackSuccess, callbackValidationErrors, companyId, cocNumber) => {
    return api(
      "post",
      `user/company/${companyId}/validate/coc`,
      (response) => callbackSuccess(response.data),
      (errors) => callbackValidationErrors(errors),
      (error) => {
        throw new Error(
          `Error in useCompanyService::userValidateCoc: ${error?.message || JSON.stringify(error)}`
        );
      },
      {coc_number: cocNumber}
    );
  }

  const userAddUser = (callbackSuccess, callbackValidationErrors, companyId, data) => {
    return api(
      'post',
      'user/company/' + companyId + '/user/invite',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userShow: ${error?.message || JSON.stringify(error)}`)
      },
      data,
    )
  }

  const userDelete = (callbackSuccess, callbackValidationErrors, companyId) => {
    return api(
      'post',
      'user/company/' + companyId + '/delete',
      response => callbackSuccess(response.data),
      errors => callbackValidationErrors(errors),
      error => {
        throw new Error(`Error in useCompanyService::userDelete: ${error?.message || JSON.stringify(error)}`)
      },
    )
  }

  return {
    objectType: 'company',
    userShow,
    userUpdate,
    userStore,
    userValidateIban,
    userValidateIbanCallback,
    userValidateCoc,
    userAddUser,
    userDelete
  }
}

export default useCompanyService
